import axios from "axios";

export const createSubscription = ({ data, paymentMethodId, backendUrl, userId}) =>
{
    const options = {
        method: 'POST',
        url: backendUrl+'/create-subscription/' + userId,
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        },
        data: {
                paymentMethodId: paymentMethodId,
                priceId: data.priceId,
                priceAmount: data.priceAmount,
                timeframeMonths: data.timeframeMonths,
                couponCodeId: data.couponCodeId,
                firstName: data.firstName,
                lastName: data.lastName,
                line1: data.line1,
                line2: data.line2,
                postalcode: data.postalcode,
                city: data.city,
                country: data.country,
                email: data.email,
                phone: data.phone
            }
    };

    return axios.request(options)
        .then(function (response)
        {
            return response; // .json does not work
        })
        .then((result) =>
        {
            if (result.error)
            {
                // setCCError(result.error.message)
                // setCCSuccess("")
                // The card had an error when trying to attach it to a customer.
                // throw result;
                return result.error.message
            }
            return "";
        })
        // Normalize the result to contain the object returned by Stripe.
        // Add the addional details we need.
        .then((result) =>
        {
            return ""
            // return {
            //     paymentMethodId: paymentMethodId,
            //     priceId: priceId,
            //     subscription: result,
            // };
        })
        // Some payment methods require a customer to be on session
        // to complete the payment process. Check the status of the
        // payment intent to handle these actions.
        .then(handleCustomerActionRequired)
        // If attaching this card to a Customer object succeeds,
        // but attempts to charge the customer fail, you
        // get a requires_payment_method error.
        // .then(handleRequiresPaymentMethod)
        // No more actions required. Provision your service for the user.
        // .then(onSubscriptionComplete)
        .catch(function (error)
        {
            // network error
            if (!error.response)
            {
                return "Payment failed due to network issues. Please try again later."
            }

            // setCCError(error.response.data)
            // setCCSuccess("")
            return error.response.data;
        })
}

function handleCustomerActionRequired({subscription, invoice, priceId, paymentMethodId, isRetry,})
{
    console.log("customer action required")

    if (subscription && subscription.status === 'active') {
        // subscription is active, no customer actions required.
        return { subscription, priceId, paymentMethodId };
    }

    // // If it's a first payment attempt, the payment intent is on the subscription latest invoice.
    // // If it's a retry, the payment intent will be on the invoice itself.
    // let paymentIntent = invoice
    //     ? invoice.payment_intent
    //     : subscription.latest_invoice.payment_intent;

    // if (
    //     paymentIntent.status === 'requires_action' ||
    //     (isRetry === true && paymentIntent.status === 'requires_payment_method')
    // ) {
    //     return stripe
    //         .confirmCardPayment(paymentIntent.client_secret, {
    //             payment_method: paymentMethodId,
    //         })
    //         .then((result) => {
    //             if (result.error) {
    //                 // start code flow to handle updating the payment details
    //                 // Display error message in your UI.
    //                 // The card was declined (i.e. insufficient funds, card has expired, etc)
    //                 throw result;
    //             } else {
    //                 if (result.paymentIntent.status === 'succeeded') {
    //                     // There's a risk of the customer closing the window before callback
    //                     // execution. To handle this case, set up a webhook endpoint and
    //                     // listen to invoice.paid. This webhook endpoint returns an Invoice.
    //                     return {
    //                         priceId: priceId,
    //                         subscription: subscription,
    //                         invoice: invoice,
    //                         paymentMethodId: paymentMethodId,
    //                     };
    //                 }
    //             }
    //         });
    // } else {
    //     // No customer action needed
    //     return { subscription, priceId, paymentMethodId };
    // }
}

export function getBackendUrl()
{
    let environment = process.env.NODE_ENV;

    // development
    let backendUrl = "http://localhost:9000/";
    // production
    if(environment == 'production')
        backendUrl = "https://admin.vatia.ch/";
    // test
    else if(environment == 'test')
        backendUrl = "https://admin.vatia.ch/";

    return backendUrl;
}